import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import Wifi from "common/svg/wifi";
import Cheap from "common/svg/cheap";
import Quality from "common/svg/quality";
import Convenient from "common/svg/convenient";
import { Card } from "./card";

import { Link } from "react-router-dom";

export interface Highlight {
  title: string;
  description: string;
  icon: JSX.Element;
}

const highlights: Highlight[] = [
  {
    title: "convenient",
    description:
      "our mobile app makes it easy to schedule a pickup and delivery.",
    icon: <Convenient />,
  },
  {
    title: "affordable",
    description: "our prices are competitive and transparent.",
    icon: <Cheap />,
  },
  {
    title: "quality",
    description: "we take pride in our work and guarantee your satisfaction.",
    icon: <Quality />,
  },
  {
    title: "free wifi",
    description: "enjoy free wifi while you wait for your laundry.",
    icon: <Wifi />,
  },
];

export const SmartwashDifference = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="lg">
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        py={theme.spacing(10)}
      >
        <Typography variant="h1" sx={
          {
            mb: 5,
            fontSize: {
              xs: 38,
              sm: 38,
              md: 48,
              lg: 54,
            },
            fontWeight: 700
          }
        }>
          Laundromat Hamilton
        </Typography>

        <Typography variant={"h4"} fontWeight={600}>
          discover the
          <Typography
            component={"span"}
            color={theme.palette.secondary.main}
            variant={"h4"}
            fontWeight={600}
          >
            {" "}
            e-smartwash{" "}
          </Typography>
          revolution!
        </Typography>

        <Typography sx={{ marginTop: "3rem" }}>
          Doing laundry should not be stressful, tedious, or time-consuming. When laundry becomes a hassle, your schedule is disrupted, isn’t it? At our laundromat in Hamilton, we make it easy and convenient to do your laundry on your schedule.
        </Typography>
        <Typography sx={{ marginTop: "15px" }} >
          With our extended hours, you can do your laundry in the morning before work or later in the evening after running all other errands. With modern machines and a customer-first approach, our Hamilton laundromat offers convenience and comfort.
        </Typography>

        <Grid
          container
          spacing={8}
          display={"flex"}
          alignItems={"start"}
          justifyContent={"start"}
          my={theme.spacing(4)}
        >
          {highlights.map((highlight, idx) => (
            <Grid
              item
              md={3}
              sm={12}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              textAlign={"center"}
              key={highlight.title}
              width={"100%"}
            >
              <Card highlight={highlight} />
            </Grid>
          ))}
        </Grid>

        {/* <Button
          LinkComponent={"a"}
          href="/pricing/"
          variant="outlined"
        >
          view our pricing
        </Button> */}

        <Link to={'/pricing/'} className="pricing_btn">
          <Typography component={'span'} fontWeight={600} sx={{ my: theme.spacing(2), color: theme.palette.secondary.main }}
          >
            view our pricing

          </Typography>
        </Link>
      </Box>
    </Container>
  );
};
